export default "__VITE_ASSET__D4ZW5OmD__"